import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'

/**
 * Leaf hook for the bookmark save-error snackbar.
 * Kept out of useSavedItemSnackbarHandlers so SelectDifferentTrip can show
 * errors without the SelectDifferentTrip ↔ useSavedItemSnackbarHandlers cycle.
 */
export default function useSaveErrorSnackbar() {
  const intl = useIntl()

  const showSaveErrorSnackbar = useCallback(
    (tripName?: string) =>
      showSnackbar(
        tripName
          ? intl.formatMessage(
              {
                id: 'Rl8OgK5jIvnd_3_udkjE',
                defaultMessage: 'Failed to save to "{tripName}"',
                description: 'Error snackbar message when saving an item to a specific trip fails',
              },
              { tripName },
            )
          : intl.formatMessage({
              id: '9qAjNeD93CWYNpUZp3ps',
              defaultMessage: 'Failed to save item',
              description: 'Error snackbar message when saving an item fails and no trip name is available',
            }),
        'critical',
      ),
    [intl],
  )

  return showSaveErrorSnackbar
}
